import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import * as AuthActions from "../data/auth/AuthActions";

import SignupForm from "Components/SignupForm";
import SignupSuccess from "Components/SignupForm/SignupSuccess";

class SignupController extends React.Component
{
    state = {
        success: false,
        form: {}
    };

    static propTypes = {
        signup: PropTypes.func.isRequired,
        loggedIn: PropTypes.bool.isRequired
    };

    signupSubmit = (form) => {
        return this.props.signup(form).then(() => {
            this.setState({success: true, form: form});
        });
    };

    render()
    {
        if (this.props.loggedIn) {
            return <Redirect to="/accounts" />;
        }

        return <div className="flex h-full w-full items-center justify-center bg-indigo-800">
            {
                this.state.success
                    ? <SignupSuccess form={this.state.form} />
                    : <SignupForm onSubmit={this.signupSubmit} />
            }
        </div>;
    }
}

const mapStateToProps = (state, ownProps) => ({
    loggedIn: !! state.auth.id,
});

const mapDispatchToProps = {
    signup: AuthActions.signUp
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SignupController)
